import React, { useState } from 'react';
import {FieldValues, useForm} from 'react-hook-form'
import { Link } from 'react-router-dom';
import CustomerService from "../services/CustomerService";

const ForgotPasswordPage = () => {

    const [ errorMessage, setErrorMessage ] = useState<string | null>(null);
    const [ loading, setLoading ] = useState(false);
    const [ emailSent, setEmailSent ] = useState(false);
    const { register, handleSubmit } = useForm();

    const onSubmit = (data: FieldValues)=>  {

        const { email } = data;

        setLoading(true);
        setErrorMessage(null);
        setEmailSent(false);

        CustomerService.forgotPassword(email)
            .then((/* response */) => {
                setLoading(false);
                setErrorMessage(null);
                setEmailSent(true);
            })
            .catch((error) => {
                setLoading(false);
                if (error.response && error.response.status) {
                    switch (error.response.status) {
                        case 401:
                            setErrorMessage(error.response.data.messages[0] || 'Invalid email and or password');
                            return;
                        case 429:
                            setErrorMessage(error.response.data.messages[0]);
                            return;
                        default:
                            // fall through
                    }
                }
                // console.log("Unexpected Error", error);
                setErrorMessage('An unexpected error occurred')
            });
    };

    return (
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-md-6 col-sm-12">

                    <form onSubmit={handleSubmit(onSubmit)}>
                        <h1 className="h3 p-3 font-weight-normal text-center">Forgot Password</h1>

                        <p>Enter your email address. We'll send you an email with a link to reset your password.</p>

                        {errorMessage &&
                            <div className="alert alert-danger" role="alert">
                                {errorMessage}
                            </div>
                        }

                        {emailSent &&
                            <div className="alert alert-success" role="alert">
                                Email Sent.  Check your email for instructions on how to recover your password.
                            </div>
                        }

                        <div className="mb-3">
                            <label htmlFor="emailAddress" className="form-label sr-only">Email</label>
                            <input
                                {...register("email", {
                                    required: "Required",
                                })}
                                type="email"
                                className="form-control"
                                placeholder="Email"
                                required
                                autoFocus
                            />
                        </div>

                        <div className="d-grid gap-2">
                            <button className="btn btn-lg btn-primary" type="submit" disabled={loading}>
                                {loading && <span className="spinner-border float-start" role="status" aria-hidden="true" />}
                                {loading ? 'Sending Email...' : 'Send Email' }
                            </button>
                        </div>

                        <p>
                            <Link className="nav-item nav-link" to="/login">Sign in?</Link>
                        </p>

                    </form>
                </div>
            </div>
        </div>
    );

}

export default ForgotPasswordPage;
